module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentCustomer) ? _c('div', {
    key: _vm.currentCustomer.id,
    staticClass: "customer-page"
  }, [_c('div', {
    staticClass: "ui-container right aligned"
  }, [_c('div', {
    staticClass: "customer-view-header"
  }, [_c('button', {
    staticClass: "ui basic button red",
    on: {
      "click": _vm.closeCustomer
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('Close this customer')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic button green",
    on: {
      "click": _vm.handleRefreshCustomer
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('Refresh')) + "\n      ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locale),
      expression: "locale"
    }],
    staticClass: "ui fluid dropdown selection",
    staticStyle: {
      "height": "45px",
      "width": "120px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.locale = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "en"
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fr"
    }
  }, [_vm._v("French")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui right floated header"
  }, [_vm._v("\n      " + _vm._s(_vm.currentCustomer.firstname) + " " + _vm._s(_vm.currentCustomer.lastname) + "\n      "), _c('h5', [_vm._v(_vm._s(_vm.currentCustomer.email))])])]), _vm._v(" "), _c('div', {
    staticClass: "ui top attached tabular menu"
  }, [_c('a', {
    staticClass: "item teal",
    class: {
      active: _vm.currentTab == 0
    },
    on: {
      "click": function($event) {
        return _vm.handleClickTab(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Cart')) + "\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "item violet",
    class: {
      active: _vm.currentTab == 1
    },
    on: {
      "click": function($event) {
        return _vm.handleClickTab(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Measures')) + "\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "item grey",
    class: {
      active: _vm.currentTab == 2
    },
    on: {
      "click": function($event) {
        return _vm.handleClickTab(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Orders')) + "\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "item blue",
    class: {
      active: _vm.currentTab == 3
    },
    on: {
      "click": function($event) {
        return _vm.handleClickTab(3)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Customer')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "ui segment attached tab teal",
    class: {
      active: _vm.currentTab == 0
    }
  }, [_c('cart-tab', {
    on: {
      "switchToOrdersTab": function($event) {
        _vm.currentTab = 2
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    key: 'measures-' + _vm.tabsKey[1],
    staticClass: "ui bottom attached tab segment violet",
    class: {
      active: _vm.currentTab == 1
    }
  }, [_c('measurement-tab', {
    ref: "measurementTab",
    attrs: {
      "customer": _vm.currentCustomer
    }
  })], 1), _vm._v(" "), _c('div', {
    key: 'orders-' + _vm.tabsKey[2],
    staticClass: "ui bottom attached tab segment grey",
    class: {
      active: _vm.currentTab == 2
    }
  }, [_c('order-tab', {
    ref: "orderTab",
    attrs: {
      "customer": _vm.currentCustomer
    }
  })], 1), _vm._v(" "), _c('div', {
    key: 'customer-' + _vm.tabsKey[3],
    staticClass: "ui bottom attached tab segment blue",
    class: {
      active: _vm.currentTab == 3
    }
  }, [_c('address-tab', {
    ref: "addressTab",
    attrs: {
      "customer": _vm.currentCustomer
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25a5990b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CustomerView.vue
// module id = 485
// module chunks = 1